import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "10", r: "8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "10", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 22h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 22v-4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Webcam";
const Webcam = memo(themed(Icon));
export {
  Webcam
};
//# sourceMappingURL=webcam.js.map
